import { Box, Container, Typography, useTheme } from "@mui/material";
import { ReactNode } from "react";
import useText from "../../../hooks/useText";

const IdentitySliderSlide = ({
    identityKey,
    identity,
    identityRank,
    children,
}: {
    identityKey: string;
    identity: string;
    identityRank: number;
    children: ReactNode;
}) => {
    const text = useText()?.identitySlider.slideContainer;
    const theme = useTheme();
    // @ts-expect-error
    const color = theme.palette.mojoColors.identities[identityKey].dark;
    return (
        <Box
            sx={{
                p: (t) => t.spacing(3),
            }}
            style={{
                backgroundColor: theme.palette.background.default,
            }}
        >
            <Container>
                <Typography color="textSecondary" variant="h3">
                    {text.identity} #{identityRank}
                </Typography>
                <Typography
                    style={{ color }}
                    sx={{
                        color,
                        marginBottom: (t) => t.spacing(2),
                    }}
                    variant="h4"
                >
                    {identity.toUpperCase()}
                </Typography>
                <div style={{ display: "flex" }}>{children}</div>
            </Container>
        </Box>
    );
};

export default IdentitySliderSlide;